import { getLDClient, initializeLDClient } from 'helpers/launchDarklyClient'

// The client-side LaunchDarkly flag that gates RBAC enforcement in this app.
// Mirrors the EPS backend kill-switch (`service.rbac-enforcement-enabled`) so the
// two can be toggled together per environment: while OFF the client gates are a
// no-op and surfaces fall back to their existing coarse role checks, exactly as
// the server does. Keep both toggled in sync per env.
export const RBAC_ENFORCEMENT_FLAG_KEY = 'admin.rbac-enforcement-enabled'

/**
 * Whether RBAC enforcement is ON for the client, read IMPERATIVELY from the
 * (non-React) LaunchDarkly client. For the route-gate helpers
 * (`abilityOnEnter`, `adminShellOnEnter`) which run outside React and cannot use
 * the `useFeatureFlags` hook.
 *
 * Fail-safe: defaults to FALSE and never throws. If the LD client isn't
 * ready/reachable, enforcement is treated as OFF so gates fall back to the
 * coarse role checks and admins are never locked out — matching the EPS server
 * kill-switch.
 *
 * React components (AdminPortalGate, RequirePermission via usePermission) should
 * prefer the `useFeatureFlags()` hook + `flags[RBAC_ENFORCEMENT_FLAG_KEY]`
 * instead of this.
 */
export async function isRbacEnforcementEnabled(): Promise<boolean> {
  try {
    await initializeLDClient()
    return (
      (await getLDClient().variation(RBAC_ENFORCEMENT_FLAG_KEY, false)) === true
    )
  } catch {
    return false
  }
}
